const modules = import.meta.glob('../docs/whatsapi/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>

const FALLBACK = '# Conteúdo indisponível\n\nEsta seção não está disponível no momento.'

export function useDocContent(slug: string): string {
  const key = `../docs/whatsapi/${slug}.md`
  const content = modules[key]
  if (!content) {
    console.warn(`[useDocContent] MD not found for slug: ${slug}`)
    return FALLBACK
  }
  return content
}
